import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const SEARCH_QUERY_KEY = 'q';

const searchQuery = ref(''); // global reactive state

export const useGlobalSearch = () => {
  const route = useRoute();
  const router = useRouter();

  searchQuery.value = (route.query[SEARCH_QUERY_KEY] as string) ?? '';

  // Keep the search box in sync when the route changes (e.g. browser back/forward).
  watch(
    () => route.query[SEARCH_QUERY_KEY],
    (value) => {
      const query = (value as string) ?? '';
      if (query !== searchQuery.value) {
        searchQuery.value = query;
      }
    },
  );

  // Reflect what the user types into the URL query so it persists with navigation.
  watch(searchQuery, (value) => {
    const current = (route.query[SEARCH_QUERY_KEY] as string) ?? '';
    if (value === current) return;

    const query = { ...route.query };
    if (value) {
      query[SEARCH_QUERY_KEY] = value;
    } else {
      delete query[SEARCH_QUERY_KEY];
    }
    router.replace({ query });
  });

  const setSearchQuery = (query: string) => {
    searchQuery.value = query;
  };

  const clearSearch = () => {
    searchQuery.value = '';
  };

  return {
    searchQuery,
    setSearchQuery,
    clearSearch,
  };
};
